"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryObserver = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const extension_telemetry_1 = require("@vscode/extension-telemetry");
const vscode = require("vscode");
const TelemetryUtilities_1 = require("./TelemetryUtilities");
class TelemetryObserver {
    constructor(packageJson, isExtensionTelemetryEnabled, extensionContext, utilityContext, telemetryReporter) {
        this.extensionContext = extensionContext;
        this.utilityContext = utilityContext;
        this.isExtensionTelemetryEnabled = false;
        this.acquisitionContext = null;
        if (telemetryReporter === undefined) {
            const connectionString = packageJson.connectionString;
            this.telemetryReporter = new extension_telemetry_1.default(connectionString !== null && connectionString !== void 0 ? connectionString : '');
        }
        else {
            this.telemetryReporter = telemetryReporter;
        }
        this.isExtensionTelemetryEnabled = isExtensionTelemetryEnabled;
        vscode.env.onDidChangeTelemetryEnabled((newIsTelemetryEnabledSetting) => {
            this.isExtensionTelemetryEnabled = newIsTelemetryEnabledSetting;
            TelemetryUtilities_1.TelemetryUtilities.setDotnetSDKTelemetryToMatch(this.isExtensionTelemetryEnabled, this.extensionContext, this.acquisitionContext, this.utilityContext).catch(() => { });
        });
    }
    setAcquisitionContext(context, underlyingAcquisitionContext) {
        context.acquisitionContext = underlyingAcquisitionContext;
        this.acquisitionContext = context;
    }
    /**
     *
     * @param event The event posted to the event stream that we subscribed to.
     * @remarks The TelemetryReporter from the VSCode library contains all of the logic when we try to send an event for us.
     * It will handle whether we should send the telemetry or not. However, it is not aware of our custom telemetry logic
     * So we might as well check both to be safe.
     *
     * However, the .NET SDK itself has its own telemetry and we must keep track of VS Code's telemetry settings for that.
     */
    post(event) {
        if (TelemetryUtilities_1.TelemetryUtilities.isTelemetryEnabled(this.isExtensionTelemetryEnabled, this.utilityContext)) {
            const properties = event.getSanitizedProperties(); // Get properties that don't contain personally identifiable data
            // Certain events get sent way too often (ex: 700 million locks acquired over a few months which is causing problems for the data team) and aren't useful for telemetry.
            // We allow suppressing certain events before even hitting the data ingestion service by doing a check here.
            if (properties && (properties === null || properties === void 0 ? void 0 : properties.suppressTelemetry) === 'true') {
                return;
            }
            if (!properties) {
                this.telemetryReporter.sendTelemetryEvent(event.eventName);
            }
            else if (event.isError) {
                this.telemetryReporter.sendTelemetryErrorEvent(event.eventName, properties);
            }
            else {
                this.telemetryReporter.sendTelemetryEvent(event.eventName, properties);
            }
        }
    }
    dispose() {
        this.telemetryReporter.dispose().catch(() => { });
    }
}
exports.TelemetryObserver = TelemetryObserver;
//# sourceMappingURL=TelemetryObserver.js.map